import { LightBar } from '../../LightBar'

export default function HostOne() {
  return (
    <div className="flex flex-col gap-4 max-w-lg m-auto">
      <LightBar lights={[1, 1, 1, 1, 1, 1, 1]} />
      <LightBar lights={[1, 1, 1, 1, 1, 1, 1]} />
      <LightBar lights={[1, 1, 1, 1, 1, 1, 1]} />
    </div>
  )
}
